import React from 'react'
import {
  Grid,
  Container,
  Typography,
  Button,
  Box,
  Stack,
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  marketingHeroSx,
  marketingHeroLayerSx,
  marketingHeroImageSx,
  marketingHeroOverlaySx,
  marketingHeroCopySx,
  marketingHeroTitleSx,
  marketingHeroSubtitleSx,
  marketingHeroBodySx,
  marketingCtaSx,
  marketingCtaLabelSx,
} from '@/housefolios-components/PublicPages/publicPageSx'

const PublicPageHero = ({
  backgroundImage,
  title,
  subtitle,
  description,
  buttonText,
  buttonIcon,
  onButtonClick,
  buttonHref,
  buttonTarget,
  className = '',
  style = {},
  overlay = true,
  overlayOpacity = 0.4,
  ...props
}) => {
  return (
    <Box className={className} style={style} sx={marketingHeroSx} {...props}>
      <Stack direction="row" sx={marketingHeroLayerSx}>
        {backgroundImage && (
          <Box
            sx={[
              marketingHeroImageSx,
              { backgroundImage: `url(${backgroundImage})` },
            ]}
          />
        )}
        {overlay && (
          <Box sx={[marketingHeroOverlaySx, { opacity: overlayOpacity }]} />
        )}
        <Box sx={marketingHeroCopySx}>
          <Container sx={{ color: '#fff', pt: '1.5rem', position: 'relative', zIndex: 25 }}>
            <Stack
              sx={{
                py: '3rem',
                textAlign: 'center',
                alignItems: 'center',
              }}
            >
              <Grid
                size={{ md: 11, lg: 10, xl: 8 }}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Box>
                  {title && (
                    <Typography variant="h2" component="h2" sx={marketingHeroTitleSx}>
                      {title}
                    </Typography>
                  )}
                  {subtitle && (
                    <Typography variant="h3" component="h3" sx={marketingHeroSubtitleSx}>
                      {subtitle}
                    </Typography>
                  )}
                  {description && (
                    <Typography variant="body1" sx={marketingHeroBodySx}>
                      {description}
                    </Typography>
                  )}
                  {buttonText && (
                    <Box sx={{ pt: '1rem' }}>
                      <Button
                        onClick={onButtonClick}
                        href={buttonHref}
                        target={buttonTarget}
                        size="large"
                        sx={marketingCtaSx}
                      >
                        <Box component="span" sx={marketingCtaLabelSx}>
                          {buttonText}
                        </Box>
                        {buttonIcon && (
                          <Box component="span" sx={{ display: 'inline-flex' }}>
                            <FontAwesomeIcon icon={buttonIcon} />
                          </Box>
                        )}
                      </Button>
                    </Box>
                  )}
                </Box>
              </Grid>
            </Stack>
          </Container>
        </Box>
      </Stack>
    </Box>
  )
}

export default PublicPageHero
